<template>
  <div>
    <v-layout row wrap justify-center>
      <ui-title-red textTitle="Presupuesto"></ui-title-red>
      <v-flex xs12 class="text-xs-center">
        <ui-simple-lsc  :vidTittle="'Presupuesto'" videoEmbed="ADMINISTRACIONDINERO36Presupuesto.mp4"></ui-simple-lsc>
      </v-flex>
      <v-flex xs12  mt-4>
        <p>
          Teniendo en cuenta sus ingresos y sus gastos, este sería su flujo de caja mensual:
        </p>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <ui-calculadora-total  :nombresCols="nombres"></ui-calculadora-total>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    modName: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      nombres: [
        "<span class='font-red'>Presupuesto</span>",
        "<span class='font-red'>Valor real</span>",
        "<span class='font-red'>Valor planeado</span>",
        "<span class='font-red'>Diferencia mensual</span>"
      ]
    };
  },
  mounted() {
    this.$store.commit("nextShow", true);
  }
};
</script>


// WEBPACK FOOTER //
// davivienda-36.vue?5e9bde8e